/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { FC, ReactNode, useEffect, useState } from "react";
import { TItem, TProduto, TSelo } from "../Produto/types";
import { Box, Button, Checkbox, Chip, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, Tooltip, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import './styles.scss';
import { Formater, LocalStorage, TypeRecords } from "src/framework/commons";
import theme from "src/theme/light";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { Selo } from "../Selo";
import { TCarrinho, TCarrinhoItem } from "../Carrinho/types";
import { resolveUploadUrl } from "src/store/global.store";
import { ComponenteType, TiposEstruturas } from "src/types";
import { CarrinhoStore } from "../Carrinho/store";

interface IDetahlhesProduto {
    produto: TProduto,
    open: boolean,
    onClose: () => void;
    onAdd: (produto: TCarrinhoItem) => void;
    adicaoDesabilitada: boolean;
    componentes: ComponenteType[] | null;
    estruturas: TiposEstruturas[] | null;
}
const DetalhesProduto: FC<IDetahlhesProduto> = ({ produto, open, onClose, onAdd, adicaoDesabilitada, componentes, estruturas }) => {
    const selosCache = LocalStorage.get("solar.selos", true) || [];
    
    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || ""

    const [adicionais, setAdicionais] = useState<TItem[]>([]);

    const [quantidade, setQuantidade] = useState<number>(1);
    const [quantidadeMax, setQuantidadeMax] = useState<number>(1);
    const [quantidadeMin, setQuantidadeMin] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    const [disableMenos, setDisableMenos] = useState<boolean>(quantidade < 2 ? true : false);

    const estrutura = () => {
        const estrutura = estruturas?.find((item: any) => item.id === produto.tipo_estrutura_id)?.nome;
        return estrutura || '';
    }

    const potencia = () => {
        return produto.potencia + ' kWp';
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        const componenteId = Number(event.target.name);
        if (checked) {
            const item = produto?.itens_adicionais?.find((item: TItem) => item.componente_id === componenteId);
            if (item) {
                setAdicionais([...adicionais, item]);
            }
        } else {
            const item = adicionais?.find((item: TItem) => item.componente_id === componenteId);
            if (item) {
                setAdicionais(adicionais.filter((_item: TItem) => _item.componente_id !== componenteId));
            }
        }
    }

    const renderNomeProduto = (item: TItem): ReactNode => {
        const componente = componentes?.find((componenteCache: any) => componenteCache?.id === item.componente_id);
        return <>{item.quantidade} und. de {componente?.modelo || ""}</>;
    }

    const resolvePreco = (): number => {
        let preco = produto?.preco || 0;
        adicionais?.forEach((item: TItem) => {
            preco += (item?.valor_com_reducao * item.quantidade) || 0;
        })
        return preco * quantidade;
    }
    useEffect(()=>{
        if(produto){
            setQuantidadeMax(produto.quantidade_maxima || quantidadeMax)
            setQuantidadeMin(produto?.quantidade_minima || quantidadeMin)
        }
        if(produto.quantidade_minima){
            if(quantidade < produto?.quantidade_minima){
                setQuantidade(produto?.quantidade_minima);
            }
        }
    },[open])

    return <Dialog className='DetalhesProduto' open={open} maxWidth="lg">
        <DialogTitle>
            <Box style={{ display: "flex", justifyContent: "space-between", flexDirection: "row" }} >
                <div style={{ display: "flex" }}>
                    {produto?.selos?.map((_selo: TSelo, index: number) => {
                        const selo = selosCache?.data?.find((seloCache: any) => seloCache?.id === _selo?.selo_id);
                        if (selo) {
                            return <Selo
                                key={`selo-${_selo.selo_id}-${index}`}
                                label={selo?.codigo_integracao}
                                title={selo?.nome}
                            />
                        }

                        return "";
                    })}
                </div>
                <Button
                    variant="text"
                    color="primary"
                    startIcon={<Close />}
                    onClick={() => { onClose() }}
                >
                    Fechar
                </Button>
            </Box>

        </DialogTitle>
        <DialogContent className="hide-scrollbar">
            <Box>
                <Chip label={produto.segmento === "on" ? "On Grid" : "Off Grid"} title={produto.segmento === "on" ? "On Grid" : "Off Grid"} color="secondary" style={{ marginRight: "4px" }} />
                <Chip label={`${estrutura()}`} title={`${estrutura()}`} color="secondary" style={{ marginRight: "4px" }} />
                <Chip label={`${potencia()}`} title={`${potencia()}`} color="secondary" style={{ marginRight: "4px" }} />
            </Box>
            <Box style={{ marginTop: "10px" }}>
                <Typography variant="h6">{produto.nome}</Typography>
            </Box>
            <Box>
                <Grid container spacing={2} style={{ marginTop: "10px" }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <img
                            // className={classes.itemImage}
                            width={300}
                            src={`//${uploadUrl}${produto.imagem}`}
                            title="Imagem ilustrativa do produto"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="subtitle2" component="p">Este kit inclui os seguintes produtos:</Typography>
                        <ul>
                            {produto?.itens?.map((item: TItem, index: number) => {
                                const componente = componentes?.find((componenteCache: any) => componenteCache?.id === item?.componente_id);
                                return <li key={`${produto.id}-${item.componente_id}-${index}`}>{componente?.nome} ({item?.quantidade} unidade{item?.quantidade > 1 ? "s" : ""})</li>
                            })}
                        </ul>

                        {/* <Typography variant="subtitle2" component="p">Detalhes:</Typography>
                        {produto?.itens?.map((item: TItem, index: number) => {
                            const componente: ComponenteType = componentesCache?.data?.find((componenteCache: any) => componenteCache?.id === item?.componente_id);
                            componente?.atributos?.map((atributo: any) => {
                                return atributosItens(atributo?.atributo, item?.componente_id)
                            })                                
                        })} */}

                        {produto?.itens_adicionais?.map((item: TItem, index: number) => {
                            return <Box key={`${produto.id}-adicional-${item.componente_id}-${index}`}>

                                {index === 0 && <Typography variant="subtitle2" component="p">Itens opcionais com adição de valor:</Typography>}
                                <Box>
                                    <FormControlLabel
                                        control={<Checkbox checked={adicionais.some(_item => _item.componente_id === item.componente_id)} onChange={handleChange} name={String(item.componente_id)} />}
                                        label={renderNomeProduto(item)}
                                    />
                                </Box>
                            </Box>
                        })}
                    </Grid>
                </Grid>
            </Box>
            <Box>
                <Grid container spacing={2} style={{ display: "flex", alignItems: "center" }}>
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <InputQuantidade
                            value={quantidade}
                            maxValue={quantidadeMax}
                            minValue={quantidadeMin}
                            disableMenos={disableMenos}
                            onChange={(_quantidade: number) => {
                                if(produto?.quantidade_minima){
                                    if(_quantidade <= produto?.quantidade_minima){
                                        setDisableMenos(true);
                                    }else{
                                        setDisableMenos(false);
                                    }
                                }else{
                                    setDisableMenos(false);
                                }
                                setQuantidade(_quantidade >= (produto?.quantidade_minima || 1) ? _quantidade : produto?.quantidade_minima || 1)
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2" color="textSecondary">A partir de:</Typography>
                        <Typography variant="h5" component="p" style={{ color: theme.palette.warning.main }}>{Formater.toString(resolvePreco(), TypeRecords.CURRENCY)} {produto?.desconto && <Chip label={`${produto.desconto}%`} style={{ marginLeft: "4px", color: theme.palette.warning.contrastText, backgroundColor: theme.palette.warning.main }} />}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <Tooltip title={quantidade > 0 ? "" : "Para prosseguir, selecione pelo menos um item."}>
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={adicaoDesabilitada || quantidade < 1 || loading}
                                    onClick={async () => {
                                        setLoading(true);
                                        if (produto) {
                                            const item: TCarrinhoItem = {
                                                id: Number(produto.id),
                                                quantidade: quantidade,
                                                produto: produto,
                                                itens_adicionais: adicionais.map((_item: TItem) => {
                                                    return {
                                                        componente_id: _item.componente_id,
                                                        quantidade: _item.quantidade,
                                                        valor: _item.valor,
                                                        valor_com_reducao: _item.valor_com_reducao
                                                    }
                                                })
                                            };

                                            const carrinho: TCarrinho | null = CarrinhoStore.getCarrinho();
                                            const find: TCarrinhoItem | undefined = carrinho?.itens?.find(i => i?.produto?.id === Number(produto.id));

                                            const quantidadeAtual = Number(find?.quantidade || 0);
                                            item.quantidade = quantidadeAtual + (Number(quantidade) || 1);
                                            if (CarrinhoStore.validaQuantidadeMaxima(item)) {
                                                item.quantidade = Number(quantidade);
                                                if (onAdd) {
                                                    await onAdd(item);
                                                }
                                            } else {
                                                item.quantidade = quantidadeAtual;
                                            }
                                        }
                                        setTimeout(() => { setLoading(false) }, 700);
                                    }}
                                >Adicionar</Button>
                            </div>
                        </Tooltip>
                    </Grid>
                    
                </Grid>
            </Box>
            <Box className="banner-container">
                {produto?.banner && <img
                    className="banner"
                    style={{ width: "100%" }}
                    // className={classes.itemImage}
                    src={`//${uploadUrl}${produto.banner}`}
                    title="Imagem ilustrativa do produto"
                />}
            </Box>
        </DialogContent>

    </Dialog>
}

export { DetalhesProduto }